import React from 'react';

import { Button } from '@components/Button';
import TextField from '@components/Formik/TextField';
import GenderInput from '@presenters/web/components/Leads/Forms/Fields/GenderInput';
import PhoneInput from '@presenters/web/components/Leads/Forms/Fields/PhoneInput';
import { CandidateFormFieldsProps } from '@presenters/web/pages/Leads/MMLPage/CandidateManagement/types';

import {
  getDistrictMembershipCandidatePath,
  getMembershipCandidatePath,
} from '@use-cases/leads';

import { localizedNavigate } from '@utils/localized-navigate';

import { useTranslation } from '@external/react-i18next';

interface Props {
  id: string;
  fieldProps: CandidateFormFieldsProps;
  districtName: string;
}

const NewCandidateForm: React.FC<Props> = ({
  id,
  fieldProps,
  districtName,
}) => {
  const { t } = useTranslation();
  const {
    name: firstName,
    label: firstNameLabel,
    required: firstNameRequired,
  } = fieldProps.firstName;
  const {
    name: lastName,
    label: lastNameLabel,
    required: lastNameRequired,
  } = fieldProps.lastName;
  const {
    name: email,
    label: emailLabel,
    required: emailRequired,
  } = fieldProps.email;
  const { phoneCode, phoneNumber } = fieldProps;
  const { gender, genderDescription } = fieldProps;
  const handleCancel = () => {
    districtName
      ? localizedNavigate(getDistrictMembershipCandidatePath(id))
      : localizedNavigate(getMembershipCandidatePath(id));
  };
  return (
    <div>
      <TextField
        name={firstName}
        label={firstNameLabel}
        required={firstNameRequired}
      />
      <TextField
        name={lastName}
        label={lastNameLabel}
        required={lastNameRequired}
      />
      <TextField
        name={email}
        label={emailLabel}
        required={emailRequired}
        LeadsForms
      />
      <PhoneInput
        fieldProps={{
          phoneCode: { ...phoneCode },
          phoneNumber: { ...phoneNumber },
        }}
      />
      <GenderInput
        fieldProps={{
          gender: { ...gender },
          genderDescription: { ...genderDescription },
        }}
      />
      <Button full className="mt-8 mb-8" dataTestId="button-test-id">
        {t('mml.add-candidate.continue-button', 'Continue')}
      </Button>
      <Button full text type="button" clickHandler={handleCancel}>
        {t('mml.add-candidate.cancel-button', 'Cancel')}
      </Button>
    </div>
  );
};

export default NewCandidateForm;
